// Colors
export const mint = "#effffc";
export const forest = "#008e8e";
export const greyLight = "#afafaf";
export const grey = "#eeeeee";
export const greyDark = "#999999";

export const blueLight = "#3594e8";
export const blue = "#0564d3";
export const blueDark = "#0446a8";
export const orangeLight = "#fdb957";
export const orange = "#f7941d";
export const orangeDark = "#ca6a02";
export const greenLight = "#63d1b3";
export const green = "#00bea3";
export const greenDark = "#039296";
export const redLight = "#f3668e";
export const red = "#ec454d";
export const redDark = "#c02035";

export const white = "#fff";
export const black = "#000";

// Others
export const drawerWidth = "18rem";
export const miniDrawerWidth = "6rem";
